'use client';

import React, { useEffect } from 'react';

export default function PWARegister() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker?.register('/sw.js')?.catch(() => {});
    }
  }, []);
  return null;
}
